// App.js
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import { useEffect } from "react";
import WOW from "wow.js";
import About from "./pages/About/About";
import HomeTwo from "./pages/Home/HomeTwo";
import Blog from "./pages/Blog/Blog";
import BlogDetailsPage from "./pages/BlogPosts/BlogDetailsPage";
import FutureOfCrypto from "./pages/BlogPosts/FutureOfCrypto";
import { useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ToastNotification from "./components/ToastNotification";
import { ToastProvider } from "./contexts/ToastContext";

// Import RainbowKit, Wagmi and TanStack Query.
import "@rainbow-me/rainbowkit/styles.css";
import {
  getDefaultConfig,
  RainbowKitProvider,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import { WagmiProvider } from "wagmi";
import { mainnet, sepolia } from "wagmi/chains";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const config = getDefaultConfig({
  appName: "Curtezan",
  projectId: "2eecfca0d2a48023dd738b464b0a0f1d",
  chains: [sepolia],
  ssr: true,
});

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
            <RainbowKitProvider
              theme={darkTheme({
                accentColor: "#7b3fe4",
                accentColorForeground: "white",
                borderRadius: "medium",
              })}
              modalSize="compact"
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="home-two" element={<HomeTwo />} />
                <Route path="blog" element={<Blog />} />
                <Route path="blog-details" element={<BlogDetailsPage />} />
                <Route
                  path="/blog/future-of-crypto"
                  element={<FutureOfCrypto />}
                />
              </Routes>
              <ToastNotification />
            </RainbowKitProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;
